import { connect } from "vuex-connect";
import { SetStartWallButton } from "../../../components";

export default connect({
  stateToProps: {
    startWallId: state => state.myWalls.startWallId,
    targetWallId: state => state.myWalls.targetWallId
  },
  actionsToProps: {
    openAlertDialog: (dispatch, value) =>
      dispatch("common/openAlertDialog", value),
    setStartWall: (dispatch, value) => dispatch("myWalls/setStartWall", value)
  },
  mutationsToProps: {
    setStartWallId: "myWalls/setStartWallId",
    setTargetWallId: "myWalls/setTargetWallId"
  }
})(SetStartWallButton.name, SetStartWallButton);
